import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Typography, CircularProgress } from '@mui/material';
import { CognitoService } from '../../services/api/auth/cognito.service';
import { logoutUser } from '../../store/slices/authSlice';
import { AppDispatch } from '../../store';
import logo from '../../assets/images/cacxi-white-logo.svg';

const LogoutCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        dispatch(logoutUser());
      } catch (error) {
        // Ignore errors during logout
      } finally {
        // Redirect to login page
        setTimeout(() => navigate('/'), 1000);
      }
    };

    handleLogout();
  }, [navigate, dispatch]);

  return (
    <Box
      className="h-screen flex flex-col items-center justify-center font-sans login-bg"
      sx={{ gap: 3 }}
    >
      <img className="w-32 mb-4" src={logo} alt="CACXI Logo" />
      <CircularProgress size={48} sx={{ color: '#a855f7' }} />
      <Typography variant="h6" sx={{ color: 'white', mt: 2 }}>
        Signing you out...
      </Typography>
    </Box>
  );
};

export default LogoutCallback;
